<template>
  <div>
    <a-card
      class="column-card box-shadow"
      :bordered="false"
      style="min-height: 400px"
    >
      <div v-for="(c, i) in data" :key="i">
        <h4 class="title">{{ c.name }}</h4>
        <div>
          <a-row :gutter="[40,40]" type="flex" justify="start">
            <a-col v-for="(item, j) in c.list" :key="j" :xs="1" :sm="2" :md="4" :lg="6" :xl="6">
                <a-card :title="item.name">
                    <div style="text-align:center;">
                        <img :src="item.icon" alt="" width="70">
                        <br>
                        <p>{{item.desc}}</p>
                        <br>
                        <a-button @click="toEvent" type="primary">我要测评</a-button>
                    </div>
                </a-card>
            </a-col>
          </a-row>
        </div>
        <a-divider></a-divider>
      </div>
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [
        {
          name: "程序设计模块",
          list: [
            {
              name: "思维逻辑",
              icon: require("../assets/icon/swqm32.svg"),
              desc: "人工智能思维逻辑及知识联想、导图等",
            },
            {
              name: "图形化编程",
              icon: require("../assets/icon/txhbcgj32.svg"),
              desc: "基于图形化编程软件人工智能程序设计技能及任务实践技巧",
            },
            {
              name: "Python",
              icon: require("../assets/icon/Python32.svg"),
              desc: "基于Python的人工智能代码程序设计技能及任务实践技巧",
            },
            {
              name: "C++",
              icon: require("../assets/icon/cpp32.svg"),
              desc: "基于C++的人工智能代码程序设计技能及任务实践技巧",
            },
            {
              name: "JavaScript",
              icon: require("../assets/icon/JavaScript32.svg"),
              desc: "基于JavaScript的人工智能程序设计技能及任务实践技巧",
            },
          ],
        },
        {
          name: "智能产品结构模块",
          list: [
            {
              name: "结构搭建",
              icon: require("../assets/icon/jgdj32.svg"),
              desc: "基于人工智能应用场景的基础建模能力和构建技巧",
            },
            {
              name: "3D智造",
              icon: require("../assets/icon/3dzz32.svg"),
              desc: "基于人工智能应用场景的基础建模能力和构建技巧",
            },
            {
              name: "VR/AR",
              icon: require("../assets/icon/VR32.svg"),
              desc: "基于VR/AR实现人工智能场景内任务的虚拟展示及互动模拟实践",
            },
          ],
        },
        {
          name: "智能控制模块",
          list: [
            {
              name: "机器人",
              icon: require("../assets/icon/jqr32.svg"),
              desc: "通过积木、非积木类机器人设备，结合程序设计和搭建技巧，实现基于人工智能应用场景的实践任务和最佳解决方案",
            },
            {
              name: "无人机",
              icon: require("../assets/icon/wrj32.svg"),
              desc: "通过无人机设备，结合程序设计和操控技巧，实现基于人工智能应用场景的实践任务和最佳解决方案",
            },
          ],
        },
        {
          name: "算法基础模块",
          list: [
            {
              name: "大数据",
              icon: require("../assets/icon/dsj32.svg"),
              desc: "运用人工智能技术结合大数据实现基于实际问题或任务的解决方案",
            },
            {
              name: "机器视觉",
              icon: require("../assets/icon/jqsj32.svg"),
              desc: "基于人工智能机器视觉算法技术实现应用场景中的问题或任务处理解决方案",
            },
            {
              name: "自然语言处理",
              icon: require("../assets/icon/zryycl32.svg"),
              desc: "基于人工智能自然语言处理算法技术实现应用场景中的问题或任务处理解决方案",
            },
            {
              name: "机器学习",
              icon: require("../assets/icon/jqxx32.svg"),
              desc: "基于人工智能机器学习算法技术实现应用场景中的问题或任务处理解决方案",
            },
            {
              name: "知识工程",
              icon: require("../assets/icon/zsgc32.svg"),
              desc: "基于人工智能知识图谱、专家系统算法技术实现应用场景中的问题或任务处理解决方案",
            },
          ],
        },
        {
          name: "应用领域模块",
          list: [
            {
              name: "智能交通",
              icon: require("../assets/icon/znjt32.svg"),
              desc: "在交通场景中，探究人工智能技术的应用模式和问题解决创新方法",
            },
            {
              name: "智能家居",
              icon: require("../assets/icon/znjj32.svg"),
              desc: "在家居场景中，探究人工智能技术的应用模式和问题解决创新方法",
            },
            {
              name: "智慧农业",
              icon: require("../assets/icon/zhny32.svg"),
              desc: "在农业场景中，探究人工智能技术的应用模式和问题解决创新方法",
            },
            {
              name: "智慧医疗",
              icon: require("../assets/icon/zhyl32.svg"),
              desc: "在医疗场景中，探究人工智能技术的应用模式和问题解决创新方法",
            },
          ],
        },
      ],
    };
  },
  methods:{
    toEvent(){
      this.$router.push({path: "/event/list", query: {type:0}});
    }
  }
};
</script>

<style scoped>
.title {
  margin: 0px 0px 0.35em;
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 2.125rem;
  line-height: 1.235;
  letter-spacing: 0.00735em;
  text-align: center;
  color: rgba(0, 0, 0, 0.87);
}
</style>